import React from 'react';
import {Row, Spin} from "antd";

const RowSpinner = () => {
    return <Row justify='center' align='middle' style={{height: '100%', width: '100%'}}><Spin size='medium'/></Row>;
};

export default RowSpinner;